/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetMultipleFilesRequest
 */
export interface GetMultipleFilesRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof GetMultipleFilesRequest
     */
    files: Array<number>;
}

export function GetMultipleFilesRequestFromJSON(json: any): GetMultipleFilesRequest {
    return GetMultipleFilesRequestFromJSONTyped(json, false);
}

export function GetMultipleFilesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMultipleFilesRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'files': json['files'],
    };
}

export function GetMultipleFilesRequestToJSON(value?: GetMultipleFilesRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'files': value.files,
    };
}


